/**
 * RefundModal - Modal for issuing refunds
 */
export default function RefundModal({
  show,
  onClose,
  refundAmount,
  setRefundAmount,
  refundReason,
  setRefundReason,
  refundType,
  setRefundType,
  onRefund,
  loading,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-xl max-w-md w-full p-6 space-y-4">
        <h3 className="text-xl font-bold text-foreground">Issue Refund</h3>
        <div>
          <label className="block text-sm text-muted-foreground mb-2">Refund Type</label>
          <select
            value={refundType}
            onChange={(e) => setRefundType(e.target.value)}
            className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="billing_error">Billing Error</option>
            <option value="service_issue">Service Issue</option>
            <option value="goodwill">Goodwill Gesture</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <label className="block text-sm text-muted-foreground mb-2">Refund Amount (Credits)</label>
          <input
            type="number"
            placeholder="Number of credits to refund"
            value={refundAmount}
            onChange={(e) => setRefundAmount(e.target.value)}
            className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div>
          <label className="block text-sm text-muted-foreground mb-2">Reason</label>
          <textarea
            placeholder="Explain the reason for this refund"
            value={refundReason}
            onChange={(e) => setRefundReason(e.target.value)}
            rows={3}
            className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <p className="text-blue-800 text-sm">
            Refund will be issued as <strong>{refundAmount || 0} credits</strong> added to user&apos;s account
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onRefund}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-lg transition"
          >
            {loading ? "Processing..." : "Issue Refund"}
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-muted hover:bg-muted/80 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
